import TomClient from "./tomClient"

export const loadPage = ({containerId, route, containerLabel}) =>
    TomClient.getEnrich("/module", {containerId, route, containerLabel})

export const loadNavigation = () => TomClient.getEnrich("/navigation")

export const loadRoots = (component) =>
    TomClient.getEnrich("/roots", {component})

export const loadTree = (treeName) => TomClient.getEnrich(`/tree/${treeName}`)

export const isBaked = false
